var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66.052,
    height: 66.052,
    viewBox: "0 0 66.052 66.052",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4010",
    "data-name": "Path 4010",
    d: "M242.026-1025A33.363,33.363,0,0,0,209-991.974a33.363,33.363,0,0,0,33.026,33.026,33.123,33.123,0,0,0,33.026-33.026A32.889,32.889,0,0,0,242.026-1025Zm-4.77,45.869-11.743-11.743,3.67-3.67,8.073,8.074,17.614-17.614,3.669,3.67Z",
    transform: "translate(-209 1025)",
    fill: "#2c53bb",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4009",
    "data-name": "Path 4009",
    d: "M192-863.862H2657.926V-1040H192Z",
    transform: "translate(-192 1040)",
    fill: "#2c53bb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26357",
    "data-name": "Group 26357",
    transform: "translate(-674.017 -529.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_-_Check_Mark_Filled_20",
    "data-name": "Icon - Check Mark / Filled / 20",
    transform: "translate(674.017 529.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3990",
    "data-name": "Group 3990",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3989",
    "data-name": "Group 3989",
    transform: "translate(-62.382 -55.043)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4008",
    "data-name": "Path 4008",
    d: "M204-1030H306.747v102.746H204Z",
    transform: "translate(-159.966 1066.695)",
    fill: "#2c53bb"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessAlert);
export default __webpack_public_path__ + "static/media/success-alert.85718ecd36136de4fb7867daa86de8c6.svg";
export { ForwardRef as ReactComponent };